import React from 'react';
import * as mobxReact from 'mobx-react';
import { CommonModal } from '../../../../../../global/modal/common/common-modal';
import { DefaultCloseModalButton } from '../../../../../../global/modal/common/common-close-modal-buttons';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { MultiSelectOption } from '../../../../../../global/multi-select-list/_multi-select-option';
import { ScheduledMeetingEmailPopupViewmodel } from './scheduled-meeting-email-popup.viewmodel';
import { ScheduledMeetingEmailsMeetingsList } from './_meeting-list/_meeting-list';
import { CONTINUE_BUTTON_TEXT, EDIT_SCHEDULED_MEETING_EMAIL_TEXT, NEW_SCHEDULED_MEETING_EMAIL_TEXT } from '../scheduled-emails-form.texts';
import { FormattedMessage } from 'react-intl';
import './scheduled-meeting-email-popup.scss';
import { AttendeeRole } from '../../../../../../../api/attendees.dao';

interface IProps {
    vm: ScheduledMeetingEmailPopupViewmodel;
}

const ScheduledMeetingEmailPopup = mobxReact.observer(({ vm }: IProps) => {
    if (!vm || !vm.isOpen) return null;

    const footer = <div className='buttons-block buttons-block--from-right'>
        <DefaultButton
            text={<FormattedMessage {...CONTINUE_BUTTON_TEXT} />}
            modifier={['fat', 'confirm-safe']}
            onClick={vm.handleSubmit}
            disabled={vm.isApplyButtonDisabled}
        />
        <DefaultCloseModalButton />
    </div>;

    const titleText = vm.isEditMode ? EDIT_SCHEDULED_MEETING_EMAIL_TEXT : NEW_SCHEDULED_MEETING_EMAIL_TEXT;

    return (
        <CommonModal
            title={<FormattedMessage {...titleText} />}
            className='create-scheduled-email-meeting-modal'
            footer={footer}
            isOpen={vm.isOpen}
            onRequestClose={vm.closePopUp}
        >
            <form className='oe-form'>
                <FormField
                    className='m-bottom-25px'
                    label={
                        <FormattedMessage
                            id='oe.websiteTab.newScheduledMeetingEmailsRoles'
                            defaultMessage='Select the {boldRoles} for which you would like to create a Scheduled Meeting Email:'
                            values={{
                                boldRoles: <b>&nbsp;Roles&nbsp;</b>,
                            }}
                        />
                    }
                >
                    <div className='oe-form__row'>
                        {
                            Object.values(AttendeeRole).map(role => {
                                const isSelected = vm.roles.includes(role);
                                const updateRolesOptions = () => {
                                    isSelected
                                        ? vm.uncheckRole(role)
                                        : vm.checkRole(role);
                                };

                                return <MultiSelectOption
                                    key={role}
                                    isSelected={isSelected}
                                    name={role}
                                    onCheckboxClick={updateRolesOptions}
                                    onClick={updateRolesOptions}
                                    isCheckboxInLeft
                                />;
                            })
                        }
                    </div>
                </FormField>
                <FormField
                    className='m-bottom-20px'
                    label={
                        <FormattedMessage
                            id='oe.websiteTab.newScheduledMeetingEmailsRoles'
                            defaultMessage='Select the {boldMeeting} for which you would like to create a Scheduled Meeting Email:'
                            values={{
                                boldMeeting: <b>&nbsp;Meeting&nbsp;</b>,
                            }}
                        />
                    }
                >
                    <ScheduledMeetingEmailsMeetingsList
                        loading={vm.loading}
                        meetings={vm.meetings}
                        selectedMeetingId={vm.meetingId}
                        pagingVM={vm.pagingVM}
                        setMeetingId={vm.setMeetingId}
                        setSortParams={vm.setSortParams}
                        sortOrder={vm.sortOrder}
                        sortField={vm.sortField}
                        timezone={vm.event.timeZone}
                        dateTimeFormatter={vm.dateTimeFormatter}
                    />
                </FormField>
            </form>
        </CommonModal>
    );
});

export { ScheduledMeetingEmailPopup };